// import React, { useState } from "react";
// import {
//   Dialog,
//   Paper,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   CircularProgress,
//   Box,
//   Typography,
// } from "@mui/material";

// const AddComplaint = ({ open, onClose, onSubmit, loading, user }) => {
//   const [complaintData, setComplaintData] = useState({
//     department: user.department || "",
//     company: user.company || "",
//     type: "",
//     description: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setComplaintData((prev) => ({ ...prev, [name]: value }));
//   };

//   const isFormValid = complaintData.type && complaintData.description.trim();

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//       <Paper sx={{ p: 3, direction: "rtl" }}>
//         <Typography variant="h5" sx={{ mb: 5, fontFamily: "Cairo", textAlign: "center" }}>
//           إضافة شكوى جديدة
//         </Typography>

//         <Box sx={{ mb: 2 }}>
//           <Select
//             name="type"
//             fullWidth
//             value={complaintData.type}
//             onChange={handleChange}
//             displayEmpty
//           >
//             <MenuItem value="" disabled>اختر نوع الشكوى</MenuItem>
//             <MenuItem value="موافقة أمنية">موافقة أمنية</MenuItem>
//             <MenuItem value="شكوى إدارية">شكوى إدارية / بلاغ</MenuItem>
//             <MenuItem value="فساد">فساد / تلاعب</MenuItem>
//           </Select>
//         </Box>

//         <TextField
//           fullWidth
//           multiline
//           rows={4}
//           label="تفاصيل الشكوى"
//           name="description"
//           value={complaintData.description}
//           onChange={handleChange}
//           sx={{ mb: 3 }}
//         />

//         <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//           <Button
//             variant="contained"
//             onClick={() => onSubmit(complaintData)}
//             disabled={!isFormValid || loading}
//             sx={{ bgcolor: "#6FD943", color: "#fff", "&:hover": { bgcolor: "#A0C878" } }}
//           >
//             {loading ? <CircularProgress size={24} /> : "إرسال"}
//           </Button>

//           <Button
//             variant="outlined"
//             onClick={onClose}
//             sx={{ bgcolor: "#f44336", color: "#fff", "&:hover": { bgcolor: "#d32f2f" } }}
//           >
//             إلغاء
//           </Button>
//         </Box>
//       </Paper>
//     </Dialog>
//   );
// };

// export default AddComplaint;

import React, { useState } from "react";
import {
  Dialog,
  Paper,
  Button,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";

const AddComplaint = ({ open, onClose, onSubmit, loading, user }) => {
  const [complaintData, setComplaintData] = useState({
    department: user.department || "",
    company: user.company || "",
    type: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setComplaintData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onSubmit(complaintData); // إرسال البيانات
    // تفريغ الحقول بعد الإضافة
    setComplaintData({ department: user.department || "", company: user.company || "", type: "", description: "" });
  };

  const isFormValid = complaintData.type && complaintData.description.trim();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <Paper sx={{ p: 3, direction: "rtl" }}>
        <Typography variant="h5" sx={{ mb: 5, fontFamily: "Cairo", textAlign: "center" }}>
          إضافة شكوى جديدة
        </Typography>

        <Box sx={{ mb: 2 }}>
          <Select
            name="type"
            fullWidth
            value={complaintData.type}
            onChange={handleChange}
            displayEmpty
          >
            <MenuItem value="" disabled>اختر نوع الشكوى</MenuItem>
            <MenuItem value="موافقة أمنية">موافقة أمنية</MenuItem>
            <MenuItem value="شكوى إدارية">شكوى إدارية / بلاغ</MenuItem>
            <MenuItem value="فساد">فساد / تلاعب</MenuItem>
          </Select>
        </Box>

        <TextField
          fullWidth
          multiline
          rows={4}
          label="تفاصيل الشكوى"
          name="description"
          value={complaintData.description}
          onChange={handleChange}
          sx={{ mb: 3 }}
        />

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            onClick={handleSubmit} 
            disabled={!isFormValid || loading}
            sx={{ bgcolor: "#6FD943", color: "#fff", "&:hover": { bgcolor: "#A0C878" } }}
          >
            {loading ? <CircularProgress size={24} /> : "إرسال"}
          </Button>

          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ bgcolor: "#f44336", color: "#fff", "&:hover": { bgcolor: "#d32f2f" } }}
          >
            إلغاء
          </Button>
        </Box>
      </Paper>
    </Dialog>
  );
};

export default AddComplaint;
